import { Component } from '@angular/core';
import { Message, MessageService, PrimeIcons } from 'primeng/api';
import { SystemNotification } from "ng/src/app/notifications/notification.model";

@Component({
	templateUrl: './p-toast-wrapper.component.html',
})
export class PToastWrapper {
	constructor(private messageService: MessageService) { }

	onCloseError() {
        this.messageService.clear('error-toast');
    }
	
	isSystemNotificationMessage(message: any): SystemNotificationMessage | undefined {
		const notification = message?.notification;
		return (typeof notification === 'object' && 'title' in notification && 'id' in notification)
			? message
			: undefined;
	}
	
	readonly Icons = PrimeIcons;
}

export interface SystemNotificationMessage extends Message {
	notification: SystemNotification,
	action: () => void
}